module.exports = __webpack_public_path__ + "img/icon-instagram.80d550ef.svg";